import {BUSINESS_COACH, BUSINESS_LEADER, COACH} from '/enum/competency.enum';

import {backgroundColor} from './background.theme';
import {bannerColors} from './banner.theme';
import competency from './competency.color';
import {iconColor} from './icon.theme';
import {textColor} from './text.theme';

export default {
  [COACH]: {
    textColor: textColor[COACH],
    backgroundColor: backgroundColor[COACH],
    gradientColors: competency[COACH].gradient,
    bannerColors: bannerColors[COACH],
    iconColor: iconColor[COACH],
  },
  [BUSINESS_COACH]: {
    textColor: textColor[BUSINESS_COACH],
    backgroundColor: backgroundColor[BUSINESS_COACH],
    gradientColors: competency[BUSINESS_COACH].gradient,
    bannerColors: bannerColors[BUSINESS_COACH],
    iconColor: iconColor[BUSINESS_COACH],
  },
  [BUSINESS_LEADER]: {
    textColor: textColor[BUSINESS_LEADER],
    backgroundColor: backgroundColor[BUSINESS_LEADER],
    gradientColors: competency[BUSINESS_LEADER].gradient,
    bannerColors: bannerColors[BUSINESS_LEADER],
    iconColor: iconColor[BUSINESS_LEADER],
  },
};
